import React, { useCallback, useEffect, useState } from "react";
import DashboardView from "../DashboardView";
import { Row, Col, Button, Input } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ResourceList from "./ResouceList";
import { getResourcesAsync, getResourceTypesAsync } from "../../redux/resourceSlice";
import Loading from "../../components/common/Spinners/Loading";

const { Search } = Input;

export default function Resources() {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const resources = useSelector((state) => state.resources);
  const groups = useSelector((state) => state.boards.groups);
  const dispatch = useDispatch();

  const onSearchColName = (value) => {
    setSearchValue(value); // <-- Track input value
    if (!value || value.trim() === "") {
      return fetchResources();
    }

    // Remove spaces from search term for flexible matching
    const searchTerm = value.trim().toLowerCase().replace(/\s+/g, "");

    const filteredData =
      resources.resourceData?.filter((item) => {
        // Remove spaces from name and resourceType for comparison
        const name = (item.name || "").toLowerCase().replace(/\s+/g, "");
        const resourceType = (item.resoueceType || "").toLowerCase().replace(/\s+/g, "");

        return name.includes(searchTerm) || resourceType.includes(searchTerm);
      }) || [];

    setData(filteredData);
  };

  const fetchResourceTypes = useCallback(() => {
    dispatch(getResourceTypesAsync());
  }, [dispatch]);

  useEffect(() => {
    fetchResourceTypes();
  }, []);

  const fetchResources = useCallback(() => {
    setSearchValue("");
    dispatch(getResourcesAsync());
  }, [dispatch]);

  useEffect(() => {
    fetchResources();
  }, []);

  useEffect(() => {
    if (resources.resourceData) {
      setData(() => [...resources.resourceData]);
    }
  }, [resources.resourceData]);

  const clearSearch = () => setSearchValue("");

  return (
    <DashboardView>
      <Row>
        <Col span={4}>
          <h2>Resources</h2>
        </Col>
        <Col span={2}></Col>
        <Col span={8}>
          <Input
            value={searchValue}
            placeholder="Search Resources By Name or Type"
            onChange={(e) => onSearchColName(e.target.value)}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={4}></Col>
        <Col span={6}>
          <Button type="primary">
            <Link to="add-resource">Add New</Link>
          </Button>
        </Col>
      </Row>
      <div>
        {resources.resourceStatus === "pending" || resources.resourceTypeStatus === "pending" ? (
          <Loading />
        ) : !data.length && resources.resourceStatus === "fulfilled" ? (
          <div
            style={{
              position: "fixed",
              bottom: "50%",
              left: "42%",
            }}
          >
            <h3>No Matching Resources Found...</h3>
          </div>
        ) : (
          <ResourceList
            clearSearch={clearSearch}
            resourceData={data.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))}
            resourceTypes={resources.resourceTypes}
            groups={groups}
          />
        )}
      </div>
    </DashboardView>
  );
}
